"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class DefaultApi extends runtime.BaseAPI {
    /**
     */
    adminInsightsServiceChangeAdminInsightsProjectOwnerRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.admininsights.v1.ChangeAdminInsightsProjectOwnerRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/admin-insights/changeadmininsightsprojectowner/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAdmininsightsV1ChangeAdminInsightsProjectOwnerRequestToJSON(requestParameters.tableauAdmininsightsV1ChangeAdminInsightsProjectOwnerRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAdmininsightsV1ChangeAdminInsightsProjectOwnerResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminInsightsServiceChangeAdminInsightsProjectOwner(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminInsightsServiceChangeAdminInsightsProjectOwnerRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    adminInsightsServiceCreateAdminInsightsProjectRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.admininsights.v1.CreateAdminInsightsProjectRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/admin-insights/createadmininsightsproject/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauAdmininsightsV1CreateAdminInsightsProjectRequestToJSON(requestParameters.tableauAdmininsightsV1CreateAdminInsightsProjectRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauAdmininsightsV1CreateAdminInsightsProjectResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminInsightsServiceCreateAdminInsightsProject(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminInsightsServiceCreateAdminInsightsProjectRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    askDataVizportalStateServiceGetAskDataVizportalStateRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/vizportal-state`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpVizportalstateVizportalstateserviceGetAskDataVizportalStateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    askDataVizportalStateServiceGetAskDataVizportalState(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.askDataVizportalStateServiceGetAskDataVizportalStateRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceClearRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceClear.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/clear`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    chatServiceClear(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.chatServiceClearRaw(requestParameters);
        });
    }
    /**
     */
    chatServiceConverseRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.chat.ConverseRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/converse`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpChatConverseRequestToJSON(requestParameters.tableauNlpChatConverseRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatConverseResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceConverse(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceConverseRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceDescribeCurrentDatasourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceDescribeCurrentDatasource.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/datasource`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatDescribeCurrentDatasourceResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceDescribeCurrentDatasource(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceDescribeCurrentDatasourceRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceDescribeCurrentLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceDescribeCurrentLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/lens`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatDescribeCurrentLensResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceDescribeCurrentLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceDescribeCurrentLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceDescribeFieldRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.chat.DescribeFieldRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/describefield`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpChatDescribeFieldRequestToJSON(requestParameters.tableauNlpChatDescribeFieldRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatDescribeFieldResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceDescribeField(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceDescribeFieldRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceGetAllInterpretationOptionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceGetAllInterpretationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/interpretations`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatGetAllInterpretationOptionsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceGetAllInterpretationOptions(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceGetAllInterpretationOptionsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceListDatasourcesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/datasources`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatListDatasourcesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceListDatasources(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceListDatasourcesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceListFieldsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceListFields.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/fields`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatListFieldsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceListFields(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceListFieldsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceListLensesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/lenses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatListLensesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceListLenses(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceListLensesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceSelectDatasourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.chat.SelectDatasourceRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/selectdatasource`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpChatSelectDatasourceRequestToJSON(requestParameters.tableauNlpChatSelectDatasourceRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    chatServiceSelectDatasource(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.chatServiceSelectDatasourceRaw(requestParameters);
        });
    }
    /**
     */
    chatServiceSelectInterpretationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.interpretationIndex === null || requestParameters.interpretationIndex === undefined) {
                throw new runtime.RequiredError('interpretationIndex', 'Required parameter requestParameters.interpretationIndex was null or undefined when calling chatServiceSelectInterpretation.');
            }
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceSelectInterpretation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/interpretations/{interpretation_index}`.replace(`{${"interpretation_index"}}`, encodeURIComponent(String(requestParameters.interpretationIndex))).replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatSelectInterpretationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceSelectInterpretation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceSelectInterpretationRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceSelectLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.chat.SelectLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/selectlens`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpChatSelectLensRequestToJSON(requestParameters.tableauNlpChatSelectLensRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    chatServiceSelectLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.chatServiceSelectLensRaw(requestParameters);
        });
    }
    /**
     */
    chatServiceShareRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceShare.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/share`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatShareResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceShare(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceShareRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceStartConversationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatStartConversationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceStartConversation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceStartConversationRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    chatServiceUndoRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
                throw new runtime.RequiredError('conversationId', 'Required parameter requestParameters.conversationId was null or undefined when calling chatServiceUndo.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/chat/conversations/{conversation_id}/undo`.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters.conversationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpChatUndoResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    chatServiceUndo(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chatServiceUndoRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceCreateDataRoleRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.datarole.v1.DataRole+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauDataroleV1DataRoleToJSON(requestParameters.tableauDataroleV1DataRole),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1DataRoleFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceCreateDataRole(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceCreateDataRoleRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceCreateDataRoleRelationshipRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.datarole.v1.CreateDataRoleRelationshipRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/relationships/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauDataroleV1CreateDataRoleRelationshipRequestToJSON(requestParameters.tableauDataroleV1CreateDataRoleRelationshipRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1DataRoleRelationshipFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceCreateDataRoleRelationship(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceCreateDataRoleRelationshipRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceDeleteDataRolesRelationshipRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/relationships/`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    dataRoleServiceDeleteDataRolesRelationship(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.dataRoleServiceDeleteDataRolesRelationshipRaw(requestParameters);
        });
    }
    /**
     */
    dataRoleServiceGetDataRoleRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fieldConceptKey === null || requestParameters.fieldConceptKey === undefined) {
                throw new runtime.RequiredError('fieldConceptKey', 'Required parameter requestParameters.fieldConceptKey was null or undefined when calling dataRoleServiceGetDataRole.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/{field_concept_key}`.replace(`{${"field_concept_key"}}`, encodeURIComponent(String(requestParameters.fieldConceptKey))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1DataRoleFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceGetDataRole(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceGetDataRoleRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceGetIndexingStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fieldConceptKey === null || requestParameters.fieldConceptKey === undefined) {
                throw new runtime.RequiredError('fieldConceptKey', 'Required parameter requestParameters.fieldConceptKey was null or undefined when calling dataRoleServiceGetIndexingStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/indexing_status/{field_concept_key}`.replace(`{${"field_concept_key"}}`, encodeURIComponent(String(requestParameters.fieldConceptKey))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauSemanticsGetIndexingStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceGetIndexingStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceGetIndexingStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceListDataRoleRelationshipsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/relationships/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1ListDataRoleRelationshipsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceListDataRoleRelationships(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceListDataRoleRelationshipsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceListDataRolesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1ListDataRolesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceListDataRoles(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceListDataRolesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataRoleServiceUpdateDataRoleRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fieldConceptKey === null || requestParameters.fieldConceptKey === undefined) {
                throw new runtime.RequiredError('fieldConceptKey', 'Required parameter requestParameters.fieldConceptKey was null or undefined when calling dataRoleServiceUpdateDataRole.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.datarole.v1.DataRole+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/{field_concept_key}`.replace(`{${"field_concept_key"}}`, encodeURIComponent(String(requestParameters.fieldConceptKey))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauDataroleV1DataRoleToJSON(requestParameters.tableauDataroleV1DataRole),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1DataRoleFromJSON(jsonValue));
        });
    }
    /**
     */
    dataRoleServiceUpdateDataRole(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataRoleServiceUpdateDataRoleRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataServiceGetFilterAndParameterInfoRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/filterParameterInfo`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringDataV1GetFilterAndParameterInfoResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataServiceGetFilterAndParameterInfo(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataServiceGetFilterAndParameterInfoRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataServiceGetLastDataFetchTimeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/lastDataFetchTime`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringDataV1GetLastDataFetchTimeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataServiceGetLastDataFetchTime(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataServiceGetLastDataFetchTimeRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataServiceGetMarkInfoRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/markInfo`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringDataV1GetMarkInfoResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataServiceGetMarkInfo(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataServiceGetMarkInfoRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataServiceGetMarkValueHistoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/markValueHistory`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringDataV1GetMarkValueHistoryResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dataServiceGetMarkValueHistory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dataServiceGetMarkValueHistoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    dataSourceModelServiceUpdateDrillPathRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.datasourceLuid === null || requestParameters.datasourceLuid === undefined) {
                throw new runtime.RequiredError('datasourceLuid', 'Required parameter requestParameters.datasourceLuid was null or undefined when calling dataSourceModelServiceUpdateDrillPath.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.datasourcemodel.v1.UpdateDrillPathRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datasourcemodel/datasources/{datasource_luid}/drillpath`.replace(`{${"datasource_luid"}}`, encodeURIComponent(String(requestParameters.datasourceLuid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauDatasourcemodelV1UpdateDrillPathRequestToJSON(requestParameters.tableauDatasourcemodelV1UpdateDrillPathRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    dataSourceModelServiceUpdateDrillPath(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.dataSourceModelServiceUpdateDrillPathRaw(requestParameters);
        });
    }
    /**
     */
    dataSourceModelServiceUpdateFieldRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.datasourceLuid === null || requestParameters.datasourceLuid === undefined) {
                throw new runtime.RequiredError('datasourceLuid', 'Required parameter requestParameters.datasourceLuid was null or undefined when calling dataSourceModelServiceUpdateField.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.datasourcemodel.v1.UpdateFieldRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datasourcemodel/datasources/{datasource_luid}/field`.replace(`{${"datasource_luid"}}`, encodeURIComponent(String(requestParameters.datasourceLuid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauDatasourcemodelV1UpdateFieldRequestToJSON(requestParameters.tableauDatasourcemodelV1UpdateFieldRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    dataSourceModelServiceUpdateField(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.dataSourceModelServiceUpdateFieldRaw(requestParameters);
        });
    }
    /**
     */
    extensionsValidationServiceValidateExtensionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.siteLuid === null || requestParameters.siteLuid === undefined) {
                throw new runtime.RequiredError('siteLuid', 'Required parameter requestParameters.siteLuid was null or undefined when calling extensionsValidationServiceValidateExtension.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.com.tableau.extensions.validationservice.ExtensionsValidationRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/sites/{site_luid}/settings/extensions:test`.replace(`{${"site_luid"}}`, encodeURIComponent(String(requestParameters.siteLuid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ComTableauExtensionsValidationserviceExtensionsValidationRequestToJSON(requestParameters.comTableauExtensionsValidationserviceExtensionsValidationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    extensionsValidationServiceValidateExtension(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extensionsValidationServiceValidateExtensionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    fieldSynonymsServiceUpsertFieldSynonymsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.synonyms.UpsertFieldSynonymsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/field-synonyms`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSynonymsUpsertFieldSynonymsRequestToJSON(requestParameters.tableauNlpSynonymsUpsertFieldSynonymsRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    fieldSynonymsServiceUpsertFieldSynonyms(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fieldSynonymsServiceUpsertFieldSynonymsRaw(requestParameters);
        });
    }
    /**
     */
    fieldSynonymsServiceValidateSynonymRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.synonyms.ValidateSynonymRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/field-synonyms/validate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSynonymsValidateSynonymRequestToJSON(requestParameters.tableauNlpSynonymsValidateSynonymRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSynonymsValidateSynonymResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fieldSynonymsServiceValidateSynonym(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fieldSynonymsServiceValidateSynonymRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    indexingSettingsServiceGetFieldIndexingSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.datasourceID === null || requestParameters.datasourceID === undefined) {
                throw new runtime.RequiredError('datasourceID', 'Required parameter requestParameters.datasourceID was null or undefined when calling indexingSettingsServiceGetFieldIndexingSettings.');
            }
            if (requestParameters.fieldGraphID === null || requestParameters.fieldGraphID === undefined) {
                throw new runtime.RequiredError('fieldGraphID', 'Required parameter requestParameters.fieldGraphID was null or undefined when calling indexingSettingsServiceGetFieldIndexingSettings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/datasources/{datasourceID}/fields/{fieldGraphID}/field-indexing-settings`.replace(`{${"datasourceID"}}`, encodeURIComponent(String(requestParameters.datasourceID))).replace(`{${"fieldGraphID"}}`, encodeURIComponent(String(requestParameters.fieldGraphID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpIndexingsettingsGetFieldIndexingSettingsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    indexingSettingsServiceGetFieldIndexingSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.indexingSettingsServiceGetFieldIndexingSettingsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    indexingSettingsServiceSetFieldIndexingSettingsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.indexingsettings.FieldIndexingSettings+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/field-indexing-settings/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpIndexingsettingsFieldIndexingSettingsToJSON(requestParameters.tableauNlpIndexingsettingsFieldIndexingSettings),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    indexingSettingsServiceSetFieldIndexingSettings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.indexingSettingsServiceSetFieldIndexingSettingsRaw(requestParameters);
        });
    }
    /**
     */
    insightsServiceGetExpectedBoundsHistoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/expectedBoundsHistory`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringInsightsV1GetExpectedBoundsHistoryResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    insightsServiceGetExpectedBoundsHistory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.insightsServiceGetExpectedBoundsHistoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    insightsServiceListMarkSignalsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/markSignals`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringInsightsV1ListMarkSignalsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    insightsServiceListMarkSignals(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.insightsServiceListMarkSignalsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    lensInternalServiceCreateLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.internalservice.CreateLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/internal-lens/lenses`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensInternalserviceCreateLensRequestToJSON(requestParameters.tableauNlpLensInternalserviceCreateLensRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensLensFromJSON(jsonValue));
        });
    }
    /**
     */
    lensInternalServiceCreateLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensInternalServiceCreateLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    lensInternalServiceGetLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.lensId === null || requestParameters.lensId === undefined) {
                throw new runtime.RequiredError('lensId', 'Required parameter requestParameters.lensId was null or undefined when calling lensInternalServiceGetLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/internal-lens/lenses/{lens_id}`.replace(`{${"lens_id"}}`, encodeURIComponent(String(requestParameters.lensId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensLensFromJSON(jsonValue));
        });
    }
    /**
     */
    lensInternalServiceGetLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensInternalServiceGetLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    lensInternalServiceModifyLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.lensLuid === null || requestParameters.lensLuid === undefined) {
                throw new runtime.RequiredError('lensLuid', 'Required parameter requestParameters.lensLuid was null or undefined when calling lensInternalServiceModifyLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.internalservice.ModifyLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/internal-lens/lenses/{lens_luid}`.replace(`{${"lens_luid"}}`, encodeURIComponent(String(requestParameters.lensLuid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensInternalserviceModifyLensRequestToJSON(requestParameters.tableauNlpLensInternalserviceModifyLensRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    lensInternalServiceModifyLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lensInternalServiceModifyLensRaw(requestParameters);
        });
    }
    /**
     */
    lensInternalServiceSetLensFieldsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.internalservice.SetLensFieldsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/internal-lens/lenses/fields`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensInternalserviceSetLensFieldsRequestToJSON(requestParameters.tableauNlpLensInternalserviceSetLensFieldsRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    lensInternalServiceSetLensFields(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lensInternalServiceSetLensFieldsRaw(requestParameters);
        });
    }
    /**
     */
    lensInternalServiceUpdateLensFieldRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.internalservice.UpdateLensFieldRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/internal-lens/lenses/fields`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensInternalserviceUpdateLensFieldRequestToJSON(requestParameters.tableauNlpLensInternalserviceUpdateLensFieldRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    lensInternalServiceUpdateLensField(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lensInternalServiceUpdateLensFieldRaw(requestParameters);
        });
    }
    /**
     */
    lensMonolithServiceCreateLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.monolithservice.CreateLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/monolith-lens/lenses`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensMonolithserviceCreateLensRequestToJSON(requestParameters.tableauNlpLensMonolithserviceCreateLensRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensMonolithserviceLensUIModelFromJSON(jsonValue));
        });
    }
    /**
     */
    lensMonolithServiceCreateLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensMonolithServiceCreateLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    lensMonolithServiceDeleteLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling lensMonolithServiceDeleteLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/monolith-lens/lenses/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    lensMonolithServiceDeleteLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lensMonolithServiceDeleteLensRaw(requestParameters);
        });
    }
    /**
     */
    lensMonolithServiceGetUserPermissionMetadataForLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/monolith-lens/lenses/permissions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensMonolithserviceGetUserPermissionMetadataForLensResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    lensMonolithServiceGetUserPermissionMetadataForLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensMonolithServiceGetUserPermissionMetadataForLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    lensMonolithServiceListLensesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/monolith-lens/lenses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensMonolithserviceListLensesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    lensMonolithServiceListLenses(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensMonolithServiceListLensesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    lensMonolithServiceUpdateLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling lensMonolithServiceUpdateLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.monolithservice.UpdateLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/monolith-lens/lenses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensMonolithserviceUpdateLensRequestToJSON(requestParameters.tableauNlpLensMonolithserviceUpdateLensRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensMonolithserviceLensUIModelFromJSON(jsonValue));
        });
    }
    /**
     */
    lensMonolithServiceUpdateLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensMonolithServiceUpdateLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    monitoredSheetsServiceAddUserRequestedViewRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.recommendations.datamonitoring.monitor.v1.AddUserRequestedViewRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/monitoredViews/userRequestedViews`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauRecommendationsDatamonitoringMonitorV1AddUserRequestedViewRequestToJSON(requestParameters.tableauRecommendationsDatamonitoringMonitorV1AddUserRequestedViewRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    monitoredSheetsServiceAddUserRequestedView(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.monitoredSheetsServiceAddUserRequestedViewRaw(requestParameters);
        });
    }
    /**
     */
    monitoredSheetsServiceListUserRequestedViewsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/monitoredViews/userRequestedViews`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauRecommendationsDatamonitoringMonitorV1ListUserRequestedViewsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    monitoredSheetsServiceListUserRequestedViews(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.monitoredSheetsServiceListUserRequestedViewsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    monitoredSheetsServiceRemoveUserRequestedViewRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.viewLuid === null || requestParameters.viewLuid === undefined) {
                throw new runtime.RequiredError('viewLuid', 'Required parameter requestParameters.viewLuid was null or undefined when calling monitoredSheetsServiceRemoveUserRequestedView.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/datamonitoring/monitoredViews/userRequestedViews/{view_luid}`.replace(`{${"view_luid"}}`, encodeURIComponent(String(requestParameters.viewLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    monitoredSheetsServiceRemoveUserRequestedView(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.monitoredSheetsServiceRemoveUserRequestedViewRaw(requestParameters);
        });
    }
    /**
     * Sends a request to cancel the transfer and train job
     * Sends a request to cancel the transfer and train job
     */
    predictiveModelControllerServiceCancelTransferAndTrainRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.jobId !== undefined) {
                queryParameters['job_id'] = requestParameters.jobId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.predictivemodelcontroller.v1.CancelTransferAndTrainRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/CancelTransferAndTrain`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPredictivemodelcontrollerV1CancelTransferAndTrainRequestToJSON(requestParameters.tableauPredictivemodelcontrollerV1CancelTransferAndTrainRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Sends a request to cancel the transfer and train job
     * Sends a request to cancel the transfer and train job
     */
    predictiveModelControllerServiceCancelTransferAndTrain(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.predictiveModelControllerServiceCancelTransferAndTrainRaw(requestParameters);
        });
    }
    /**
     * Deletes Salesforce user credentials in credential service for a specific actor
     * Deletes Salesforce user credentials in credential service for a specific actor
     */
    predictiveModelControllerServiceDeleteSalesforceUserCredentialsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/DeleteSalesforceUserCredentials`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1DeleteSalesforceUserCredentialsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Deletes Salesforce user credentials in credential service for a specific actor
     * Deletes Salesforce user credentials in credential service for a specific actor
     */
    predictiveModelControllerServiceDeleteSalesforceUserCredentials(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceDeleteSalesforceUserCredentialsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deploys trained model by calling Einstein Discovery endpoint
     * Deploys trained model by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceDeployModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.predictivemodelcontroller.v1.DeployModelRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/DeployModel`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPredictivemodelcontrollerV1DeployModelRequestToJSON(requestParameters.tableauPredictivemodelcontrollerV1DeployModelRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1DeployModelResponseFromJSON(jsonValue));
        });
    }
    /**
     * Deploys trained model by calling Einstein Discovery endpoint
     * Deploys trained model by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceDeployModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceDeployModelRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves transfer and train result
     * Retrieves transfer and train result
     */
    predictiveModelControllerServiceGetJobResultRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.jobId !== undefined) {
                queryParameters['job_id'] = requestParameters.jobId;
            }
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetJobResult`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1GetJobResultResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves transfer and train result
     * Retrieves transfer and train result
     */
    predictiveModelControllerServiceGetJobResult(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetJobResultRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get model metrics by calling Einstein Discovery endpoint
     * Get model metrics by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceGetModelMetricsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.timespan !== undefined) {
                queryParameters['timespan'] = requestParameters.timespan;
            }
            if (requestParameters.count !== undefined) {
                queryParameters['count'] = requestParameters.count;
            }
            if (requestParameters.deployedModelId !== undefined) {
                queryParameters['deployed_model_id'] = requestParameters.deployedModelId;
            }
            if (requestParameters.predictionDefinitionId !== undefined) {
                queryParameters['prediction_definition_id'] = requestParameters.predictionDefinitionId;
            }
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetModelMetrics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1GetModelMetricsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get model metrics by calling Einstein Discovery endpoint
     * Get model metrics by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceGetModelMetrics(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetModelMetricsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get prediction definition name from id by calling TCRM
     * Get prediction definition name from id by calling TCRM
     */
    predictiveModelControllerServiceGetPredictDefNameRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.predictionDefinitionId !== undefined) {
                queryParameters['prediction_definition_id'] = requestParameters.predictionDefinitionId;
            }
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetPredictDefName`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1GetPredictDefNameResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get prediction definition name from id by calling TCRM
     * Get prediction definition name from id by calling TCRM
     */
    predictiveModelControllerServiceGetPredictDefName(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetPredictDefNameRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves authentication status for a specific actor
     * Retrieves authentication status for a specific actor
     */
    predictiveModelControllerServiceGetSalesforceAuthStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetSalesforceAuthStatus`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1SalesForceAuthenticationStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves authentication status for a specific actor
     * Retrieves authentication status for a specific actor
     */
    predictiveModelControllerServiceGetSalesforceAuthStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetSalesforceAuthStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves training results by calling Einstein Discovery endpoint
     * Retrieves training results by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceGetTrainingResultsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.runId !== undefined) {
                queryParameters['run_id'] = requestParameters.runId;
            }
            if (requestParameters.storyId !== undefined) {
                queryParameters['story_id'] = requestParameters.storyId;
            }
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetTrainingResults`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1GetTrainingResultsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves training results by calling Einstein Discovery endpoint
     * Retrieves training results by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceGetTrainingResults(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetTrainingResultsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves training status by calling Einstein Discovery endpoint
     * Retrieves training status by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceGetTrainingStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.runId !== undefined) {
                queryParameters['run_id'] = requestParameters.runId;
            }
            if (requestParameters.storyId !== undefined) {
                queryParameters['story_id'] = requestParameters.storyId;
            }
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetTrainingStatus`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1GetTrainingStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves training status by calling Einstein Discovery endpoint
     * Retrieves training status by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceGetTrainingStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetTrainingStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves Transfer and Train status
     * Retrieves Transfer and Train status
     */
    predictiveModelControllerServiceGetTransferAndTrainStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.jobId !== undefined) {
                queryParameters['job_id'] = requestParameters.jobId;
            }
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/GetTransferAndTrainStatus`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves Transfer and Train status
     * Retrieves Transfer and Train status
     */
    predictiveModelControllerServiceGetTransferAndTrainStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceGetTransferAndTrainStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Prints out a hello world to the user
     * Prints out a hello world to the user
     */
    predictiveModelControllerServiceSayHelloRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.predictivemodelcontroller.v1.SayHelloRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/SayHello`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPredictivemodelcontrollerV1SayHelloRequestToJSON(requestParameters.tableauPredictivemodelcontrollerV1SayHelloRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1SayHelloResponseFromJSON(jsonValue));
        });
    }
    /**
     * Prints out a hello world to the user
     * Prints out a hello world to the user
     */
    predictiveModelControllerServiceSayHello(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceSayHelloRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Update model threshold by calling Einstein Discovery endpoint
     * Update model threshold by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceSetModelThresholdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.predictivemodelcontroller.v1.SetModelThresholdRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/SetModelThreshold`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPredictivemodelcontrollerV1SetModelThresholdRequestToJSON(requestParameters.tableauPredictivemodelcontrollerV1SetModelThresholdRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1SetModelThresholdResponseFromJSON(jsonValue));
        });
    }
    /**
     * Update model threshold by calling Einstein Discovery endpoint
     * Update model threshold by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceSetModelThreshold(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceSetModelThresholdRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Starts training model by calling Einstein Discovery endpoint
     * Starts training model by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceStartTrainingRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.predictivemodelcontroller.v1.StartTrainingModelRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/StartTraining`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPredictivemodelcontrollerV1StartTrainingModelRequestToJSON(requestParameters.tableauPredictivemodelcontrollerV1StartTrainingModelRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1StartTrainingModelResponseFromJSON(jsonValue));
        });
    }
    /**
     * Starts training model by calling Einstein Discovery endpoint
     * Starts training model by calling Einstein Discovery endpoint
     */
    predictiveModelControllerServiceStartTraining(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceStartTrainingRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Starts data transfer and train
     * Starts data transfer and train
     */
    predictiveModelControllerServiceStartTransferAndTrainRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.predictivemodelcontroller.v1.StartTransferAndTrainRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/predictivemodel/StartTransferAndTrain`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPredictivemodelcontrollerV1StartTransferAndTrainRequestToJSON(requestParameters.tableauPredictivemodelcontrollerV1StartTransferAndTrainRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPredictivemodelcontrollerV1StartTransferAndTrainResponseFromJSON(jsonValue));
        });
    }
    /**
     * Starts data transfer and train
     * Starts data transfer and train
     */
    predictiveModelControllerServiceStartTransferAndTrain(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.predictiveModelControllerServiceStartTransferAndTrainRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    quillServiceGetHealthRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling quillServiceGetHealth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/quill/health/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuillV1HealthResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    quillServiceGetHealth(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.quillServiceGetHealthRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    quillServiceWriteStoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.quill.v1.StoryRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/quill/v2/stories/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuillV1StoryRequestToJSON(requestParameters.tableauQuillV1StoryRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuillV1StoryResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    quillServiceWriteStory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.quillServiceWriteStoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceAddPhraseRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.AddPhraseRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:addPhrase`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiAddPhraseRequestToJSON(requestParameters.tableauNlpRefinementuiAddPhraseRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiAddPhraseResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceAddPhrase(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceAddPhraseRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceEntitySearchRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.EntitySearchRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:entitySearch`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiEntitySearchRequestToJSON(requestParameters.tableauNlpRefinementuiEntitySearchRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiEntitySearchResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceEntitySearch(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceEntitySearchRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceGetPhraseBuilderFieldsAndOptionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.GetPhraseBuilderFieldsAndOptionsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:getPhraseBuilderFieldsAndOptions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiGetPhraseBuilderFieldsAndOptionsRequestToJSON(requestParameters.tableauNlpRefinementuiGetPhraseBuilderFieldsAndOptionsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiGetPhraseBuilderFieldsAndOptionsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceGetPhraseBuilderFieldsAndOptions(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceGetPhraseBuilderFieldsAndOptionsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceGetRecommendedPhrasesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.GetRecommendedPhrasesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:getRecommendedPhrases`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiGetRecommendedPhrasesRequestToJSON(requestParameters.tableauNlpRefinementuiGetRecommendedPhrasesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiGetRecommendedPhrasesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceGetRecommendedPhrases(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceGetRecommendedPhrasesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceInterpretationParserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.InterpretationParserRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:interpretationParser`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiInterpretationParserRequestToJSON(requestParameters.tableauNlpRefinementuiInterpretationParserRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiInterpretationParserResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceInterpretationParser(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceInterpretationParserRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceListCategoricalValuesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.ListCategoricalValuesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:listCategoricalValues`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiListCategoricalValuesRequestToJSON(requestParameters.tableauNlpRefinementuiListCategoricalValuesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiListCategoricalValuesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceListCategoricalValues(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceListCategoricalValuesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServicePhrasesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.PhrasesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:phrases`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiPhrasesRequestToJSON(requestParameters.tableauNlpRefinementuiPhrasesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiPhrasesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServicePhrases(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServicePhrasesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    refinementUIServiceSearchFieldsAndValuesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.refinementui.SearchFieldsAndValuesRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/refinement-ui/name:searchFieldsAndValues`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpRefinementuiSearchFieldsAndValuesRequestToJSON(requestParameters.tableauNlpRefinementuiSearchFieldsAndValuesRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpRefinementuiSearchFieldsAndValuesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    refinementUIServiceSearchFieldsAndValues(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refinementUIServiceSearchFieldsAndValuesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    semanticModelGetDataRoleAssociationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/associations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSemanticmodelGetDataRoleAssociationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    semanticModelGetDataRoleAssociation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.semanticModelGetDataRoleAssociationRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    semanticModelGetDatasourceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/datasource`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSemanticmodelGetDatasourceResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    semanticModelGetDatasource(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.semanticModelGetDatasourceRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    semanticModelGetDetailedLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/detailed-lens`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSemanticmodelGetDetailedLensResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    semanticModelGetDetailedLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.semanticModelGetDetailedLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    semanticModelSetDataRoleAssociationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.semanticmodel.SetDataRoleAssociationRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/associations`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSemanticmodelSetDataRoleAssociationRequestToJSON(requestParameters.tableauNlpSemanticmodelSetDataRoleAssociationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSemanticmodelSetDataRoleAssociationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    semanticModelSetDataRoleAssociation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.semanticModelSetDataRoleAssociationRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    sharingServiceShareRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.sharing.ShareRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/sharing/viz:share`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSharingShareRequestToJSON(requestParameters.tableauNlpSharingShareRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSharingShareResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    sharingServiceShare(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.sharingServiceShareRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    suggestionServiceGetAllGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.datasourceId === null || requestParameters.datasourceId === undefined) {
                throw new runtime.RequiredError('datasourceId', 'Required parameter requestParameters.datasourceId was null or undefined when calling suggestionServiceGetAllGroups.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/datasources/{datasource_id}/suggestions`.replace(`{${"datasource_id"}}`, encodeURIComponent(String(requestParameters.datasourceId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSuggestionsGetAllGroupsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    suggestionServiceGetAllGroups(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.suggestionServiceGetAllGroupsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    suggestionServiceGetAllGroupsForLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.lensLuid === null || requestParameters.lensLuid === undefined) {
                throw new runtime.RequiredError('lensLuid', 'Required parameter requestParameters.lensLuid was null or undefined when calling suggestionServiceGetAllGroupsForLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/lenses/{lens_luid}/suggestions`.replace(`{${"lens_luid"}}`, encodeURIComponent(String(requestParameters.lensLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSuggestionsGetAllGroupsForLensResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    suggestionServiceGetAllGroupsForLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.suggestionServiceGetAllGroupsForLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    suggestionServiceSetAllGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.datasourceId === null || requestParameters.datasourceId === undefined) {
                throw new runtime.RequiredError('datasourceId', 'Required parameter requestParameters.datasourceId was null or undefined when calling suggestionServiceSetAllGroups.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.suggestions.SetAllGroupsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/ask-data/datasources/{datasource_id}/suggestions`.replace(`{${"datasource_id"}}`, encodeURIComponent(String(requestParameters.datasourceId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSuggestionsSetAllGroupsRequestToJSON(requestParameters.tableauNlpSuggestionsSetAllGroupsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSuggestionsSetAllGroupsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    suggestionServiceSetAllGroups(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.suggestionServiceSetAllGroupsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    syntheticHealthServiceCheckHealthRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/-/messagebus/synthetic-health`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    syntheticHealthServiceCheckHealth() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.syntheticHealthServiceCheckHealthRaw();
        });
    }
    /**
     */
    syntheticMonitoringHealthServiceCheckSyntheticHealthRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/-/ask-data/synthetic-health`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    syntheticMonitoringHealthServiceCheckSyntheticHealth() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.syntheticMonitoringHealthServiceCheckSyntheticHealthRaw();
        });
    }
    /**
     */
    valueConceptServiceListValueConceptsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fieldConceptKey === null || requestParameters.fieldConceptKey === undefined) {
                throw new runtime.RequiredError('fieldConceptKey', 'Required parameter requestParameters.fieldConceptKey was null or undefined when calling valueConceptServiceListValueConcepts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/{field_concept_key}/value-concepts`.replace(`{${"field_concept_key"}}`, encodeURIComponent(String(requestParameters.fieldConceptKey))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1ListValueConceptsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    valueConceptServiceListValueConcepts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.valueConceptServiceListValueConceptsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    valueConceptServiceUpdateValueConceptsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fieldConceptKey === null || requestParameters.fieldConceptKey === undefined) {
                throw new runtime.RequiredError('fieldConceptKey', 'Required parameter requestParameters.fieldConceptKey was null or undefined when calling valueConceptServiceUpdateValueConcepts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.datarole.v1.UpdateValueConceptsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/data-roles/{field_concept_key}/value-concepts`.replace(`{${"field_concept_key"}}`, encodeURIComponent(String(requestParameters.fieldConceptKey))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauDataroleV1UpdateValueConceptsRequestToJSON(requestParameters.tableauDataroleV1UpdateValueConceptsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauDataroleV1UpdateValueConceptsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    valueConceptServiceUpdateValueConcepts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.valueConceptServiceUpdateValueConceptsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    valueSynonymsServiceGetValuesAndValueSynonymsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/value-synonym`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSynonymsGetValuesAndValueSynonymsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    valueSynonymsServiceGetValuesAndValueSynonyms(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.valueSynonymsServiceGetValuesAndValueSynonymsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    valueSynonymsServiceUpsertUserDefValueSynonymRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.synonyms.UpsertUserDefValueSynonymRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/value-synonym`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSynonymsUpsertUserDefValueSynonymRequestToJSON(requestParameters.tableauNlpSynonymsUpsertUserDefValueSynonymRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSynonymsUpsertUserDefValueSynonymResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    valueSynonymsServiceUpsertUserDefValueSynonym(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.valueSynonymsServiceUpsertUserDefValueSynonymRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    valueSynonymsServiceValidateUserDefValueSynonymRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.synonyms.ValidateUserDefValueSynonymRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/semantic-model/value-synonym/validate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpSynonymsValidateUserDefValueSynonymRequestToJSON(requestParameters.tableauNlpSynonymsValidateUserDefValueSynonymRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpSynonymsValidateUserDefValueSynonymResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    valueSynonymsServiceValidateUserDefValueSynonym(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.valueSynonymsServiceValidateUserDefValueSynonymRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.DefaultApi = DefaultApi;
